module.exports = "/v2/pages/dashboard/dist/dfc3f01ade7fe083e6e13380043a5e1e.svg";